import React from 'react';

let d = new Date();
let currentYear = d.getFullYear();

const Footer = (props) => (
  <footer className="footer">
    <div className="container d-flex flex-row flex-wrap align-items-center justify-content-center">
      {props.children}
      <div className="item copyright">Copyright © {currentYear} Kambria.io</div>
      <div className="item contact">
        <a href="mailto:info@kambria.io" className="color-gray color-base-hover">
          info@kambria.io
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
